import { NgModule } from '@angular/core';

import { ViagensComponent } from "./viagens.component";
import {SharedModule} from "../shared/shared.module";
import {ViagensRoutingModule} from "./viagens-routing.module";
import {DeslocamentoTiposModule} from "./deslocamento-tipos/deslocamento-tipos.module";
import {PontosModule} from "./pontos/pontos.module";
import {DeslocamentosModule} from "./deslocamentos/deslocamentos.module";
import {ViagemMenuComponent} from "./shared/viagem-menu/viagem-menu.component";
import {ViagemService} from "./shared/viagem.service";
import {ViagemConfiguracaoComponent} from "./configuracao/viagem-configuracao.component";
import {DestinosModule} from "./destinos/destinos.module";
import {PassageirosModule} from "./passageiros/passageiros.module";
import {VisitanteViagemMenuComponent} from "./shared/visitante-viagem-menu/visitante-viagem-menu.component";
import {TiposViagemModule} from "./tipos-viagem/tipos-viagem.module";

@NgModule({
    imports: [
        SharedModule,
        DeslocamentoTiposModule,
        PontosModule,
        DeslocamentosModule,
        DestinosModule,
        PassageirosModule,
        TiposViagemModule,
        ViagensRoutingModule
    ],
    providers: [
        ViagemService
    ],
    declarations: [
        ViagensComponent,
        ViagemMenuComponent,
        VisitanteViagemMenuComponent,
        ViagemConfiguracaoComponent
    ],
    exports: [
        ViagemMenuComponent,
        VisitanteViagemMenuComponent
    ]
})
export class ViagensModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/viagens.module.ts
 **/